import { registerModal } from 'features/Modal/ModalRegistry'
import RatesModal from './RatesModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'RATES_MODAL'
registerModal(modalType, RatesModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/RatesModal/RatesModal.action.js